import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { Notification } from '../../../common/notification'
import { AnalyseVersus } from './AnalyseVersus'
import { HighRiskCompanies } from './HighRiskCompanies'
import { Table } from './Table'
import classes from './index.module.scss'
import { selectData, selectLoading } from './store/slice'

export const PortfolioOverviewContent = ({ isDynamicReport }) => {
  const data = useSelector(selectData)
  const isLoading = useSelector(selectLoading())

  const isNoData = !isLoading && (!data || !Object.keys(data).length)

  if (isNoData && isDynamicReport) {
    return <Notification isDynamicReport />
  }

  return (
    <div className={classes.p12}>
      {!isDynamicReport && <AnalyseVersus />}
      <div className="dFlex mt1 positionRelative flexWrap">
        {isNoData ? (
          <Notification
            isDynamicReport={isDynamicReport}
            style={{ width: '100%', textAlign: 'center' }}
          />
        ) : (
          <>
            {isLoading && (
              <Loading style={{ backgroundColor: '#FFFFFF', zIndex: 1 }} />
            )}
            <div
              className={isDynamicReport ? 'w100' : 'w85'}
              id="PORTFOLIO_OVERVIEW_TABLE_ID"
            >
              <Table isDynamicReport={isDynamicReport} />
            </div>
            <div className={isDynamicReport ? 'w100' : 'w15 pl3'}>
              {!isDynamicReport && (
                <>
                  <Element
                    className="fw500 pb1"
                    style={{ fontSize: 20, opacity: 1 }}
                  >
                    &nbsp;
                  </Element>
                </>
              )}
              <div className={classes.p10}>&nbsp;</div>
              <HighRiskCompanies isDynamicReport={isDynamicReport} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}
